import React from 'react';
import { Cpu, Gauge, MonitorCog, Package, Wrench, Headphones } from 'lucide-react';
import { products } from '../mock';

export const Products = () => {
  const icons = [Cpu, Gauge, MonitorCog, Package, Wrench, Headphones];

  return (
    <section id="products" className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Products & Services
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto mb-6"></div>
          <p className="text-lg text-slate-600 max-w-3xl mx-auto">
            Custom-built vulcanizing solutions tailored to your industrial requirements
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {products.map((product, index) => {
            const Icon = icons[index];
            return (
              <div 
                key={product.id}
                className="group bg-slate-50 p-6 md:p-8 rounded-lg hover:bg-blue-600 transition-all duration-300 shadow-md hover:shadow-xl"
              >
                <Icon size={40} className="text-blue-600 group-hover:text-white mb-4 transition-colors duration-300" />
                <h3 className="text-xl font-semibold text-slate-900 group-hover:text-white mb-3 transition-colors duration-300">
                  {product.title}
                </h3>
                <p className="text-slate-600 group-hover:text-blue-50 transition-colors duration-300">
                  {product.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
